import { createAction } from '@reduxjs/toolkit';

export const AUTH_LOGOUT_SAGA = 'AUTH_LOGOUT_SAGA';
export const logOutSaga = createAction(AUTH_LOGOUT_SAGA);
